
/**
 *
 * @param {string} token JWT (Authorization)
 * @param {Object} data
 * @param {string} data.item_id                 
 * @param {string} data.code_etablissement    
 */
async function returnLoan(API_BASE, token, data) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    //console.log("Données de retour:", data);
    const workRes = await fetch(`${API_BASE}/loans/${data.item_id}/return`, {
        method: "PUT", // Using POST for an action-based endpoint is common, or PUT if updating a loan directly
        headers,

    });

    if (!workRes.ok) {
        throw new Error(await workRes.text());
    }

    const result = await workRes.json();
    //console.log("Retour enregistré avec succès:", result);

    return result;
}
export default returnLoan;
